module.exports = __webpack_public_path__ + "static/img/alarmImg.e070f9fa.png";